import type { ReactNode } from 'react'

import type { SectionsAppAdvertisingComponent } from '@twisto/api-cms'

import { Media } from '../../article-components'
import { Button, DynamicContent } from '../../atoms'
import { QRWidget } from '../../molecules'

import * as styles from './app-advertising.styles'

type Props = Omit<SectionsAppAdvertisingComponent, 'text'> & {
  text?: string | ReactNode
}

const getAppAdvertisingTextContent = (text: string | ReactNode) => {
  if (typeof text === 'string') {
    return <DynamicContent content={text} />
  }

  return text
}

export const AppAdvertising = ({ cta, src, text, widget }: Props) => (
  <section css={styles.benefits}>
    <div className="app-advertising-container" css={styles.container}>
      <div className="app-advertising-content" css={styles.main}>
        {getAppAdvertisingTextContent(text)}
        <div css={styles.cta}>
          {cta?.map((button) => <Button key={button.id} {...button} />)}
        </div>
      </div>
      {src && (
        <div css={styles.media}>
          <picture>
            <Media src={src} />
          </picture>
          {widget && <QRWidget styles={styles.widget} {...widget} />}
        </div>
      )}
    </div>
  </section>
)
